import React, { useState, useEffect } from "react";
import { useStoreState } from 'easy-peasy';
import { Container, Row, Alert } from "react-bootstrap";
import VideoConversionsComponent from "../../components/videos/videoDetails/VideoConversionsComponent.jsx";
import Loader from "../../components/widgets/Loader.jsx";
import axios from '../../services/axios.js';

const AllVideoConversionsPage = () => {

    const [allConversions, setAllConversions] = useState(null);
    const [isFetchingAllConversions, setIsFetchingAllConversions] = useState(false);

    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);

    useEffect(() => {
        if (!allConversions && !isFetchingAllConversions) {
            setIsFetchingAllConversions(true);
            const fetchAllConversionsUrl = ACTIONS?.['videoConversions']?.['readAll']?.url;
            axios.get(fetchAllConversionsUrl)
                .then((result) => {
                    setAllConversions(result);
                })
                .finally(() => setIsFetchingAllConversions(false));
        }
    }, []);

    return <Container fluid>
        <Row>
            <h2 className="d-flex">
                Conversions des XP
            </h2>
        </Row>
        <Row className="mt-2 mb-4 d-flex justify-content-between align-items-center">
            <Alert variant='info' className='mt-2'>
                <i className="fas fa-plus me-2" />
                Les XP à convertir sont recensées toutes les heures à XX:45 si aucune conversion n'est déjà en cours
                <br />
                <i className="fas fa-plus me-2" />
                Les conversions sont ensuite lancées à XX:55
                <br />
                <i className="fas fa-plus me-2" />
                Les fichiers vidéos sont associés aux XP à XX:45 une fois que toutes les conversions en cours
                sont terminées - après le <em>Traitement fini - (^^)</em> du petit robot
            </Alert>
        </Row>
        {(!allConversions || isFetchingAllConversions) ?
            <Loader />
            : <VideoConversionsComponent conversions={allConversions} />
        }
    </Container>;
};

export default AllVideoConversionsPage;